import React from 'react';

// Three premium tasbih (prayer beads) icon designs, stroke/fill use currentColor.
const Classic = (props) => (
  <svg viewBox="0 0 24 24" fill="none" {...props}>
    {[
      [19, 11], [16.95, 15.95], [12, 18], [7.05, 15.95],
      [5, 11], [7.05, 6.05], [12, 4], [16.95, 6.05],
    ].map(([cx, cy], i) => (
      <circle key={i} cx={cx} cy={cy} r="1.45" fill="currentColor" />
    ))}
    <path d="M12 18.2 V21" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    <circle cx="12" cy="22" r="1.1" fill="currentColor" />
  </svg>
);

const Strand = (props) => (
  <svg viewBox="0 0 24 24" fill="none" {...props}>
    <circle cx="12" cy="3.4" r="1.5" fill="currentColor" />
    <circle cx="12" cy="7.2" r="1.5" fill="currentColor" />
    <circle cx="12" cy="11" r="1.7" fill="currentColor" />
    <path d="M12 12.6 C12 15 9.5 16 9.5 18.5 M12 12.6 C12 15 14.5 16 14.5 18.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <circle cx="9.5" cy="19.6" r="1.2" fill="currentColor" />
    <circle cx="14.5" cy="19.6" r="1.2" fill="currentColor" />
  </svg>
);

const Crescent = (props) => (
  <svg viewBox="0 0 24 24" fill="none" {...props}>
    {[
      [4.5, 7], [4, 11], [5.2, 14.7], [7.8, 17.6], [11.4, 19],
    ].map(([cx, cy], i) => (
      <circle key={i} cx={cx} cy={cy} r="1.35" fill="currentColor" />
    ))}
    <path d="M19 5.2 a7 7 0 1 0 1.6 11.2 5.4 5.4 0 1 1 -1.6 -11.2 Z" fill="currentColor" />
    <path d="M11.4 19 l1.4 2.2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <circle cx="13" cy="22" r="1" fill="currentColor" />
  </svg>
);

const VARIANTS = { classic: Classic, strand: Strand, crescent: Crescent };

export const TASBIH_ICON_OPTIONS = [
  { id: 'classic', label: 'Klasik' },
  { id: 'strand', label: 'Untaian' },
  { id: 'crescent', label: 'Bulan Sabit' },
];

const TasbihIcon = ({ variant = 'classic', className = 'w-6 h-6' }) => {
  const Cmp = VARIANTS[variant] || Classic;
  return <Cmp className={className} />;
};

export default TasbihIcon;
